import locale from 'localization';

export const usersColumns = [
  { key: 'firstName', text: locale.firstName, width: '20%' },
  { key: 'lastName', text: locale.lastName, width: '20%' },
  { key: 'username', text: locale.username, width: '20%' },
  { key: 'role', text: locale.role, width: '15%' },
  { key: 'status', text: locale.status, width: '15%' },
  { key: 'options', text: '', width: '5%' }
];
